// This component is used to display the patient name [ LastName, FirstName] and date of birth in the patient table.
import React from 'react';

const PatientRowName = ({ fName, lName, dob }) => {
  return (
    <th scope="row">
      <div style={{ marginTop: '-1rem' }}>
        {lName ? `${lName}, ${fName}` : fName}
      </div>
      <div style={{ marginBottom: '-1rem', fontWeight: 'normal' }}>{dob}</div>
    </th>
  );
};

export default PatientRowName;
